var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"16px","text-align":"center","vertical-align":"center","position":"absolute","left":"50%","top":"30%","transform":"translate(-50%, -40%)"}},[_vm._v("正在支付中,请稍后……")])
}
var staticRenderFns = []

export { render, staticRenderFns }